import Base from './base'

export default {
  get (year, make, model, type) {
    return Base
      .get(`/${type}seatstylematchvariation/make/${make}/model/${model}/year/${year}/variations`)
      .then(res => res.data)
  }
}
